$('footer .nav-sec .acc-trigger').on('click', function () {
  $(this).next().stop().slideToggle();
});

$('.qa_sec .qaArea dt').on('click', function () {
  $(this).next(".aArea").stop().slideToggle();
  $(this).find(".tgl").toggleClass("open");
});




